import { ElementRef, Injectable, NgZone } from '@angular/core';
import { IMapPoint } from '../interfaces/iMapPoint';
import { EnvironmentService } from './environment.service';
import config from '@arcgis/core/config.js';
import Map from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import BasemapToggle from '@arcgis/core/widgets/BasemapToggle';
import Zoom from '@arcgis/core/widgets/Zoom';
import Graphic from '@arcgis/core/Graphic';
import Query from '@arcgis/core/rest/support/Query';
import MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import ScaleBar from '@arcgis/core/widgets/ScaleBar';
import Measurement from "@arcgis/core/widgets/Measurement.js"
import Expand from '@arcgis/core/widgets/Expand';

@Injectable({
    providedIn: 'root'
})
export class MapService {
    map?: Map;
    mapView?: MapView;
    randomPointsLayer?: FeatureLayer;
    layerUrl: string;
    public mapImgLayer: MapImageLayer;
    public parBoundary: FeatureLayer;
    public parcelLayer: FeatureLayer;
    public belediyeLayer: FeatureLayer;

    public arcserverurl: string;
    public amanaMapservice: string;
    public amanaFeatureService: string;
    public streets: string;
    public MadinahAerialPhotography: string;
    public CorrectedParcels: string;
    public MP_TANZEEM: string;
    public Finall_plans: string;
    public Neigh_region: string;
    public zoon: string;
    public BELEDIYE: string;

    public streetsLayer: string;
    public madinahAphotoLayer: string;
    public corrParcelLayer: string;
    public mpTanzeemLayer: string;
    public finalPlansLayer: string;
    public neighRegLayer: string;
    public zoonLayer: string;
    public baladiyaLayer: string;

    constructor(private readonly environment: EnvironmentService, private http: HttpClient) { }


    load(): Observable<any> {
        return this.http.get("./assets/config.json");
    }

    setConfigData(data: any): void {
        this.arcserverurl = data['arcserverurl'];
        this.amanaMapservice = data['amanaMapservice'];
        this.amanaFeatureService = data['amanaFeatureService'];
        this.streets = data['streets'];
        this.MadinahAerialPhotography = data['MadinahAerialPhotography'];
        this.CorrectedParcels = data['CorrectedParcels'];
        this.MP_TANZEEM = data['MP_TANZEEM'];
        this.Finall_plans = data['Finall_plans'];
        this.Neigh_region = data['Neigh_region'];
        this.zoon = data['zoon'];
        this.BELEDIYE = data['BELEDIYE'];

        this.streetsLayer = `${this.arcserverurl}${this.amanaFeatureService}${this.streets}`;
        this.madinahAphotoLayer = `${this.arcserverurl}${this.amanaFeatureService}${this.MadinahAerialPhotography}`;
        this.corrParcelLayer = `${this.arcserverurl}${this.amanaFeatureService}${this.CorrectedParcels}`;
        this.mpTanzeemLayer = `${this.arcserverurl}${this.amanaFeatureService}${this.MP_TANZEEM}`;
        this.finalPlansLayer = `${this.arcserverurl}${this.amanaFeatureService}${this.Finall_plans}`;
        this.neighRegLayer = `${this.arcserverurl}${this.amanaFeatureService}${this.Neigh_region}`;
        this.zoonLayer = `${this.arcserverurl}${this.amanaFeatureService}${this.zoon}`;
        this.baladiyaLayer = `${this.arcserverurl}${this.amanaFeatureService}${this.BELEDIYE}`;
    }

    // Initialize a default Map object for the app, which is rendered with a MapView that is bound to the DOM
    // element inside parameter 'mapElementRef'
    public initDefaultMap(mapElementRef?: ElementRef): void {
        // Set this property when using routes in order to resolve the /assets correctly.
        // IMPORTANT: the directory path may be different between your product app and your dev app
        // config.assetsPath = "/assets";
        config.assetsPath = '/assets';
        // config.request.proxyUrl = '/src/proxy.conf.json';

        this.map = new Map({
            basemap: this.environment.baseConfigs.defaultMapSettings.basemapId
        });
        // debugger;
        this.mapView = new MapView({
            map: this.map,
            center: [
                this.environment.baseConfigs.defaultMapSettings.centerLon,
                this.environment.baseConfigs.defaultMapSettings.centerLat
            ],
            // spatialReference:{
            //   wkid: 3857//32637
            // },
            zoom: this.environment.baseConfigs.defaultMapSettings.zoomLevel,
            container: mapElementRef?.nativeElement,

            ui: {
                components: ['attribution']
            }
        });
    }

    getMapView(): MapView | undefined {
        return this.mapView;
    }

    // Create instances of widgets and add them to the MapView
    public addAllMapWidgets(): void {
        const basemapToggle = new BasemapToggle({
            view: this.mapView,
            nextBasemap:
                this.environment.baseConfigs.defaultMapSettings.widgets
                    .basemapToggle.nextBasemap
        });

        const zoom = new Zoom({
            view: this.mapView
        });

        const scalebar = new ScaleBar({
            view: this.mapView
        });
        this.mapView.ui.add(scalebar, "bottom-left");


        this.mapView?.ui.add(
            basemapToggle,
            this.environment.baseConfigs.defaultMapSettings.widgets
                .basemapToggle.position
        );
        this.mapView?.ui.add(
            zoom,
            this.environment.baseConfigs.defaultMapSettings.widgets.zoom
                .position
        );
    }

    public removeAllPoints(zoomToDefaultExtent: boolean): void {
        this.map?.removeAll();

        if (zoomToDefaultExtent) {
            this.mapView?.goTo({
                center: [
                    this.environment.baseConfigs.defaultMapSettings.centerLon,
                    this.environment.baseConfigs.defaultMapSettings.centerLat
                ],
                zoom: this.environment.baseConfigs.defaultMapSettings.zoomLevel
            });
        }
    }

    public async addPointsToMap(mapPoints: Array<IMapPoint>): Promise<void> {
        this.removeAllPoints(false);

        const graphics = mapPoints.map((point, i) => {
            return new Graphic({
                attributes: {
                    ObjectId: i + 1,
                    location: point.location
                },
                geometry: {
                    type: 'point',
                    longitude: point.lon,
                    latitude: point.lat
                }
            } as any);
            // TODO: Check error "Type is not assignable to type 'GeometryProperties'. Object literal may only specify known properties, and
            // 'type' does not exist in type 'RendererProperties'."
        });

        const randomPointsLayer = new FeatureLayer({
            source: graphics,
            objectIdField: 'OBJECTID',
            renderer: {
                type: 'simple',
                symbol: {
                    type: 'simple-marker',
                    color: '#ffff00',
                    size: '12px',
                    outline: {
                        color: '#0d0d0d',
                        width: 1.5
                    }
                }
            } as any,
            // TODO: Check error "Type is not assignable to type 'RendererProperties'. Object literal may only specify known properties, and
            // 'type' does not exist in type 'RendererProperties'."
            popupTemplate: {
                title: 'Map points',
                content: [
                    {
                        type: 'fields',
                        fieldInfos: [
                            {
                                fieldName: 'location',
                                label: 'Location',
                                visible: true
                            },
                            {
                                fieldName: 'latitude',
                                label: 'Latitude',
                                visible: true
                            },
                            {
                                fieldName: 'longitude',
                                label: 'longitude',
                                visible: true
                            }
                        ]
                    }
                ]
            }
        });

        this.map?.layers.add(randomPointsLayer);

        await this.zoomToLayerExtent(randomPointsLayer);
    }

    public async zoomToLayerExtent(layer: FeatureLayer): Promise<void> {
        this.mapView?.goTo(await layer.queryExtent());
        const extent = await layer.queryExtent();
    }

    // Add the updateMapWithQuery method
    public async updateMapWithQuery(query: string): Promise<void> {
        this.removeAllPoints(false); // Clear existing points

        // Define the query based on your requirements
        const queryTask = this.randomPointsLayer.createQuery();
        queryTask.where = query;

        // Execute the query and get the features
        const queryResults =
            await this.randomPointsLayer.queryFeatures(queryTask);

        if (queryResults && queryResults.features) {
            // Create graphics from the query results
            const graphics = queryResults.features.map((feature) => {
                return new Graphic({
                    attributes: feature.attributes,
                    geometry: feature.geometry
                });
            });

            // Create a new feature layer with the filtered graphics
            const filteredPointsLayer = new FeatureLayer({
                source: graphics,
                objectIdField: 'OBJECTID', // Make sure the field name matches your data
                renderer: this.randomPointsLayer.renderer, // Use the same renderer as the original layer
                popupTemplate: this.randomPointsLayer.popupTemplate // Use the same popup template
            });

            // Add the filtered layer to the map
            this.map?.layers.add(filteredPointsLayer);

            // Zoom to the extent of the filtered layer
            await this.zoomToLayerExtent(filteredPointsLayer);
        }
    }

    configureMapLayer() {
        this.parBoundary = new FeatureLayer({
            url: 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5',
            title: ' طبقة المخططات '
            // visible: false
        });
        this.parcelLayer = new FeatureLayer({
            url: 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2',
            title: ' طبقة الأراضي '
        });

        this.belediyeLayer = new FeatureLayer({
            url: "https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/MapServer/8",
            // title: " طبقة البلدية ",
            // visible: false
        });
        this.layerUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/MapServer';
        //'http://192.168.1.106:6080/arcgis/rest/services/amanaTest/amanaTest/MapServer';
        //              "https://144.76.146.59:6443/arcgis/rest/services/amanaTest/amanaTest/MapServer";

        let sublayerTitles = [
            'طبقة البلديات',
            'طبقة النطاقات',
            'طبقة الأحياء',
            'طبقة المخططات',
            'طبقة مناطق الإعلان',
            'طبقة البلوكات',
            'طبقة الأراضي المصححة',
            'طبقة نطاق التصوير الجوي',
            'طبقة الشوارع'
        ];

        this.mapImgLayer = new MapImageLayer({
            url: this.layerUrl,
            sublayers: [
                {
                    id: 8,
                    title: sublayerTitles[0]
                },
                {
                    id: 7,
                    title: sublayerTitles[1]
                },
                {
                    id: 6,
                    title: sublayerTitles[2]
                },
                {
                    id: 5,
                    title: sublayerTitles[3]
                },
                {
                    id: 4,
                    title: sublayerTitles[4]
                },
                {
                    id: 3,
                    title: sublayerTitles[5]
                },
                {
                    id: 2,
                    title: sublayerTitles[6]
                },
                {
                    id: 1,
                    title: sublayerTitles[7]
                },
                {
                    id: 0,
                    title: sublayerTitles[8]
                }
            ]
        });

        this.mapImgLayer.load().then(() => {
            this.map.layers.add(this.mapImgLayer);
        });
    }

}
